<div [ngStyle]="fontSize()">
    <app-game-replay-opponent></app-game-replay-opponent>
    <app-game-replay-board></app-game-replay-board>
    <app-game-replay-player></app-game-replay-player>
</div>